const FooterNavToggle = (className) => {
	if (!className) {
		return;
	}

	// select all clickable elements
	const clickableElements = document.querySelectorAll(`${className}`);

	// toggle navigation
	if (window.innerWidth < 1053) {
		[...clickableElements]?.forEach((element) => {
			element.onclick = () => {	
				const accordion = element.parentNode.parentNode
				accordion.classList.toggle("denhaag-link-group--open")
				element.setAttribute(
					'aria-expanded', 
					element.getAttribute('aria-expanded') === 'true' 
					? 'false' 
					: 'true'
				);
			}
		});
	}
};

export default FooterNavToggle;
